import {
  AspectRatio,
  BorderStyle,
  Box,
  Color,
  GridDisplay,
  Image,
  withCitrusTheme,
} from '@gousto-internal/citrus-react'
import type { DashboardExperienceOrderResponse } from '@library/api-dashboard-experience'
import React from 'react'
import EmptyPlateJPG from '../../../../../my-gousto-page/src/assets/emptyPlate.png'

const StyledImage = withCitrusTheme(Image, () => ({
  filter: 'drop-shadow(10px 17px 11px #00000021)',
  boxShadow:
    '1px 2px 5px 0px #0000001A, 4px 8px 9px 0px #00000017, 10px 17px 12px 0px #0000000D, 18px 31px 14px 0px #00000003, 28px 48px 16px 0px #00000000',
  borderRadius: '50%',
}))

const MAX_RECIPE_SLOTS = 5

const RecipePlaceholder = () => (
  <AspectRatio ratio={1 / 1}>
    <Box
      borderStyle={BorderStyle.Dashed}
      borderColor={Color.ColdGrey_200}
      borderWidth={0.5}
      width="100%"
      data-testid="empty-recipe-image"
      paddingBottom={[1, 3]}
      paddingH={[1, 3]}
      paddingRight={[1, 3]}
      paddingV={[1, 3]}
    >
      <StyledImage src={EmptyPlateJPG} alt="Recipe placeholder" />
    </Box>
  </AspectRatio>
)

const RecipeTile = ({ src }: { src: string }) => (
  <AspectRatio ratio={1 / 1}>
    <Image src={src} alt="Recipe Image" />
  </AspectRatio>
)

type OrderTileRecipesProps = {
  orderId: string
  recipes: DashboardExperienceOrderResponse['recipes']
}

export const OrderTileRecipes = ({ orderId, recipes }: OrderTileRecipesProps) => {
  const recipeSlots = Array.from({ length: MAX_RECIPE_SLOTS }, (_, index) => recipes[index] ?? null)

  return (
    <Box
      width={['100%', '100%', '75%']}
      display={GridDisplay.Grid}
      gridTemplateColumns={`repeat(${MAX_RECIPE_SLOTS}, 1fr)`}
      gap={[2, 4]}
    >
      {recipeSlots.map((recipe, index) => (
        <Box key={`${orderId}-recipe-slot-${index}`} width="100%">
          {recipe?.image_url ? <RecipeTile src={recipe.image_url} /> : <RecipePlaceholder />}
        </Box>
      ))}
    </Box>
  )
}
